// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function checkValid(input) {
  const __x = input.current;
  const valid = Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
    return el.checkValidity();
  }));
  if (valid !== undefined) {
    return Caml_option.valFromOption(valid);
  } else {
    return true;
  }
}

function focusInput(input) {
  setTimeout((function (param) {
    const __x = input.current;
    Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
      return el.focus();
    }));
  }), 0);
}

function Field(Props) {
  let label = Props.label;
  let type_Opt = Props.type_;
  let name = Props.name;
  let value = Props.value;
  let onChange = Props.onChange;
  let classNameOpt = Props.className;
  let requiredOpt = Props.required;
  let colorOpt = Props.color;
  let topActiveOpt = Props.topActive;
  let topPassiveOpt = Props.topPassive;
  let disabledOpt = Props.disabled;
  const type_ = type_Opt !== undefined ? type_Opt : "text";
  const className = classNameOpt !== undefined ? classNameOpt : "";
  const required = requiredOpt !== undefined ? requiredOpt : false;
  const color = colorOpt !== undefined ? colorOpt : "text-gray-landing";
  const topActive = topActiveOpt !== undefined ? topActiveOpt : "top-1.5";
  const topPassive = topPassiveOpt !== undefined ? topPassiveOpt : "top-3.5";
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const match = React.useState(function () {
    return false;
  });
  const setFocused = match[1];
  const match$1 = React.useState(function () {
    return true;
  });
  const setValid = match$1[1];
  const inputRef = React.useRef(null);
  const active = value === "" && !match[0] ? false : true;
  React.useEffect((function () {
    const intrvl = setTimeout((function (param) {
      Curry._1(setValid, (function (param) {
        return checkValid(inputRef);
      }));
    }), 0);
    return (function (param) {
      clearTimeout(intrvl);
    });
  }), [value]);
  const labelTop = active ? topActive : topPassive;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("label", {
        children: label,
        className: Cn.fromList({
          hd: active ? "caption" : "paragraph",
          tl: {
            hd: "absolute transition-all duration-100 whitespace-nowrap " + labelTop,
            tl: {
              hd: match$1[0] || !active ? color : "text-alert",
              tl: /* [] */ 0
            }
          }
        })
      }),
      JsxRuntime.jsx("input", {
        ref: inputRef,
        className: "paragraph text-black-landing bg-bg w-full input-invalid",
        disabled: disabled,
        name: name,
        required: required,
        type: type_,
        value: value,
        onFocus: (function (param) {
          Curry._1(setFocused, (function (param) {
            return true;
          }));
        }),
        onBlur: (function (param) {
          Curry._1(setFocused, (function (param) {
            return false;
          }));
        }),
        onChange: (function (ev) {
          Curry._1(onChange, ev.target.value);
        })
      })
    ],
    className: Cn.fromList({
      hd: "flex items-end relative",
      tl: {
        hd: className,
        tl: /* [] */ 0
      }
    }),
    onClick: (function (param) {
      Curry._1(setFocused, (function (param) {
        return true;
      }));
      focusInput(inputRef);
    })
  });
}

const make = Field;

export {
  checkValid,
  focusInput,
  make,
}
/* react Not a pure module */
